module.exports = __webpack_public_path__ + "img/Australia.d2d96fc4.png";